import {
  BREAKPOINT,
  DIALOG_TYPE,
  layoutConfig,
  LayoutConfig,
  LayoutSlotConfig,
  SlotConfig,
  SlotGroup,
  SpinnerComponent
} from '@spartacus/storefront'

// Add a custom slot to the layout configuration. It will be unknown to SAP, but known and editable by FirstSpirit.
const config: LayoutConfig = layoutConfig
const footer = config.layoutSlots?.footer as SlotConfig
const navigation = config.layoutSlots?.navigation as SlotGroup
const header = config.layoutSlots?.header as SlotGroup

footer.slots?.unshift('PreFooterSlot')

if (!config.layoutSlots) {
  config.layoutSlots = {} as LayoutSlotConfig
}

if (!navigation[BREAKPOINT.lg]) {
  navigation[BREAKPOINT.lg] = { slots: [] }
}
navigation[BREAKPOINT.lg].slots = ['NavigationBar']

if (!header[BREAKPOINT.lg]) {
  header[BREAKPOINT.lg] = { slots: [] }
}
navigation[BREAKPOINT.lg].slots = []

const cartPageTemplate = config.layoutSlots?.CartPageTemplate as any
const cartPageTemplateSlotsSM = [
  'PageHeaderContentSlot',
  'UpperRightContentSlot',
  'UpperLeftContentSlot',
  'TopContent',
  'CenterRightContentSlot',
  'CenterRightContentSlotEU',
  'CenterRightContentSlotUS',
  'EmptyCartMiddleContent',
  'BottomContent'
]
const cartPageTemplateSlotsLG = [
  'PageHeaderContentSlot',
  'UpperLeftContentSlot',
  'UpperRightContentSlot',
  'CenterRightContentSlot',
  'CenterRightContentSlotEU',
  'CenterRightContentSlotUS',
  'TopContent',
  'EmptyCartMiddleContent',
  'BottomContent'
]
cartPageTemplate[BREAKPOINT.xs] = []
cartPageTemplate[BREAKPOINT.sm] = []
cartPageTemplate[BREAKPOINT.md] = []
cartPageTemplate[BREAKPOINT.lg] = []
cartPageTemplate[BREAKPOINT.xl] = []
cartPageTemplate[BREAKPOINT.xs]['slots'] = cartPageTemplateSlotsSM
cartPageTemplate[BREAKPOINT.sm]['slots'] = cartPageTemplateSlotsSM
cartPageTemplate[BREAKPOINT.md]['slots'] = cartPageTemplateSlotsSM
cartPageTemplate[BREAKPOINT.lg]['slots'] = cartPageTemplateSlotsLG
cartPageTemplate[BREAKPOINT.xl]['slots'] = cartPageTemplateSlotsLG

config.layoutSlots.SplitLoginRegisterPageTemplate = {
  slots: ['header', 'main', 'CenterLeftContentSlot', 'CenterRightContentSlot', 'CenterRightContentSlotEU', 'CenterRightContentSlotUS']
}
config.layoutSlots.RegistrationPageTemplate = {
  slots: ['header', 'main', 'PageHeaderContentSlot', 'BodyContent', 'UpperRightContentSlot']
}
config.layoutSlots.MiltenyiMultiStepCheckoutSummaryPageTemplate = {
  slots: ['header', 'main', 'PageHeaderContentSlot', 'BodyContent', 'UpperRightContentSlot']
}
config.layoutSlots.AccountPageTemplate = {
  slots: ['PageHeaderContentSlot', 'BodyContent', 'UpperRightContentSlot']
}

config.layoutSlots.MACSPickupPointTemplate = {
  slots: ['BodyContent']
}

config.layoutSlots.applicationpage = { slots: ['header', 'main'] }
config.layoutSlots.applicationprotocolspage = { slots: ['header', 'main'] }
config.layoutSlots.backgroundpage = { slots: ['header', 'main'] }
config.layoutSlots.congresspage = { slots: ['header', 'main'] }
config.layoutSlots.macshandbookpage = { slots: ['header', 'main'] }
config.layoutSlots.contentpage = { slots: ['header', 'main'] }
config.layoutSlots.homepage = { slots: ['header', 'main'] }
config.layoutSlots.instrumentpage = { slots: ['header', 'main'] }
config.layoutSlots.miltenyiuniversity = { slots: ['header', 'main'] }
config.layoutSlots.productlandingpage = { slots: ['header', 'main'] }
config.layoutSlots.LandingPage2Template = { slots: ['header', 'main'] }
config.layoutSlots.seolandingpage = { slots: ['header', 'main'] }
config.layoutSlots.contentPageCMS = { slots: ['header', 'main'] }
config.layoutSlots.faqpage = { slots: ['main'] }
config.layoutSlots.jobdetailpage = { slots: ['header', 'main'] }
config.layoutSlots.pouploadtemplate = { slots: ['header', 'main'] }

config.layoutSlots.CountrySelectionRegistrationPageTemplate = {
  slots: ['header', 'main', 'PageHeaderContentSlot', 'BodyContent']
}

const searchResultsListPageTemplate = config.layoutSlots?.SearchResultsListPageTemplate as any
const searchResultsListPageTemplateSlotsSM = [
  'SearchTopContentSlot',
  'SearchMoreFiltersContentSlot',
  'SearchResultsHeaderContentSlot',
  'SearchResultsListContentSlot'
]
const searchResultsListPageTemplateSlotsLG = [
  'SearchTopContentSlot',
  'SearchTopFiltersContentSlot',
  'SearchMoreFiltersContentSlot',
  'SearchResultsHeaderContentSlot',
  'SearchResultsListContentSlot'
]
searchResultsListPageTemplate[BREAKPOINT.xs] = { slots: searchResultsListPageTemplateSlotsSM }
searchResultsListPageTemplate[BREAKPOINT.sm] = { slots: searchResultsListPageTemplateSlotsSM }
searchResultsListPageTemplate[BREAKPOINT.md] = { slots: searchResultsListPageTemplateSlotsLG }
searchResultsListPageTemplate[BREAKPOINT.lg] = { slots: searchResultsListPageTemplateSlotsLG }
searchResultsListPageTemplate[BREAKPOINT.xl] = { slots: searchResultsListPageTemplateSlotsLG }

config.layoutSlots.CustomerDataCloudPageTemplate = {
  slots: ['header', 'main', 'BodyContent']
}

config.layoutSlots.PurchaseOrderUploadPageTemplate = {
  slots: ['header', 'main', 'PageHeaderContentSlot', 'TopContent']
}

config.layoutSlots.PurchaseOrderUploadConfirmationPageTemplate = {
  slots: ['header', 'main', 'PageHeaderContentSlot', 'TopContent']
}

config.launch = {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  MB_SPINNER: {
    inline: true,
    component: SpinnerComponent,
    dialogType: DIALOG_TYPE.POPOVER_CENTER_BACKDROP,
  }
}

export const customLayoutConfig = config
